import { ReactNode } from 'react';

interface Props {
  containerSize?: 'sm' | 'md' | 'lg' | 'full';
  children?: ReactNode;
}

export const Container = ({ containerSize = 'lg', children }: Props) => {
  let maxWidth = 'max-w-full';
  if (containerSize === 'sm') {
    maxWidth = 'max-w-[720px]';
  } else if (containerSize === 'md') {
    maxWidth = 'max-w-[912px]';
  } else if (containerSize === 'lg') {
    maxWidth = 'max-w-[1104px]';
  }

  return (
    <div className="flex flex-1 pt-10 flex-col gap-4 md:gap-8 px-6 md:px-8">
      <div className={`container px-0 py-0 mx-auto ${maxWidth}`}>{children}</div>
    </div>
  )
};
